module.exports = __webpack_public_path__ + "files/6693a0f9d6219d0875a392e3be21da14.png";